import React from 'react';

interface Props {
  width: number;
  height: number;
  color: string;
  Scores: string;
  textcolor: string;
  toolTipText: string;
}

const Score = (props: Props) => {
  const { width, height, color, Scores, textcolor, toolTipText } = props;
  const fontSize = Math.round(height * 0.8);

  return (
    <div
      id={`scoresnoncanvas-${toolTipText}-wrapper`}
      className="flex items-center justify-center"
      style={{
        width: `${width}px`,
        height: `${height}px`,
        backgroundColor: color,
        fontSize: `${fontSize}px`,
        color: textcolor,
        lineHeight: `${fontSize * 1.2}px`,
      }}
      title={toolTipText} // Display tooltip on hover
    >
      {Scores}
    </div>
  );
};

export default Score;
